var _a, _b, _c;
var DATE_COLUMNS = ['CreationDate', 'LastModified'];
export var dateComparator = function (columnName) { return function (itemA, itemB) {
    return new Date(itemA[columnName]).getTime() - new Date(itemB[columnName]).getTime();
}; };
export var S3_RESOURCE_SELECTOR_ITEM_TYPES;
(function (S3_RESOURCE_SELECTOR_ITEM_TYPES) {
    S3_RESOURCE_SELECTOR_ITEM_TYPES["BUCKETS"] = "buckets";
    S3_RESOURCE_SELECTOR_ITEM_TYPES["OBJECTS"] = "objects";
    S3_RESOURCE_SELECTOR_ITEM_TYPES["VERSIONS"] = "versions";
})(S3_RESOURCE_SELECTOR_ITEM_TYPES || (S3_RESOURCE_SELECTOR_ITEM_TYPES = {}));
export var DEFAULT_IS_ITEM_DISABLED = (_a = {},
    _a[S3_RESOURCE_SELECTOR_ITEM_TYPES.BUCKETS] = function () { return false; },
    _a[S3_RESOURCE_SELECTOR_ITEM_TYPES.OBJECTS] = function () { return false; },
    _a[S3_RESOURCE_SELECTOR_ITEM_TYPES.VERSIONS] = function (version) { return version.IsDeleteMarker; },
    _a);
export var DEFAULT_VISIBLE_COLUMNS = (_b = {},
    _b[S3_RESOURCE_SELECTOR_ITEM_TYPES.BUCKETS] = ['Name', 'Region', 'CreationDate'],
    _b[S3_RESOURCE_SELECTOR_ITEM_TYPES.OBJECTS] = ['Key', 'LastModified', 'Size'],
    _b[S3_RESOURCE_SELECTOR_ITEM_TYPES.VERSIONS] = ['CreationDate', 'ID', 'Size'],
    _b);
export var PAGE_SIZES = (_c = {},
    _c[S3_RESOURCE_SELECTOR_ITEM_TYPES.BUCKETS] = 20,
    _c[S3_RESOURCE_SELECTOR_ITEM_TYPES.OBJECTS] = 100,
    _c[S3_RESOURCE_SELECTOR_ITEM_TYPES.VERSIONS] = 20,
    _c);
export var getSortableColumns = function (columnDefinitions) {
    return columnDefinitions.map(function (columnDefinition) {
        var sortDefinition = {
            id: columnDefinition.id,
            field: columnDefinition.id
        };
        if (DATE_COLUMNS.indexOf(columnDefinition.id) > -1) {
            sortDefinition.comparator = dateComparator(columnDefinition.id);
        }
        return sortDefinition;
    });
};
export var getNextItemsTypeForObject = function (item) {
    return item.IsFolder
        ? S3_RESOURCE_SELECTOR_ITEM_TYPES.OBJECTS
        : S3_RESOURCE_SELECTOR_ITEM_TYPES.VERSIONS;
};
export var versionToOption = function (version) {
    return {
        id: version.ID,
        label: new Date(version.CreationDate).toISOString(),
        disabled: version.IsDeleteMarker
    };
};
export var sortColumnDefinitions = function (columnDefinitions, visibleColumns) {
    return visibleColumns
        .map(function (columnName) {
        return columnDefinitions.filter(function (columnDefinition) { return columnDefinition.id === columnName; })[0];
    })
        .filter(function (columnDefinition) { return columnDefinition; });
};
//# sourceMappingURL=s3-config.js.map